import { Component, Input, OnDestroy, OnInit, HostListener } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import { ColorConfig } from '../../../analytics-core/interfaces/widget.interface';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';

@Component({
	selector: 'app-product-lift-chart-r10',
	styleUrls: ['./product-lift-chart-r10.component.css'],
	templateUrl: './product-lift-chart-r10.component.html'
})
export class ProductLiftChartR10Component implements OnInit, WidgetCore, OnDestroy {
	public key: string;
	public timeserieskey: string;
	@Input() secondarykey: string;
	@Input() sectionclass: string;
	@Input() colorsconfig: any;
	@Input() sectiontitle: string;
	@Input() uikitresponseconfig: any;
	@Input() customchartconfiguration: any;

	public tooltipOptions = {
		position: 'top',
		animation: 'fade',
		arrow: true,
		duration: 750,
		scale: 'big',
		dynamicTitle: true,
		allowTitleHTML: true
	};
	public campaignsList = [];
	public campaignCarouselItem: any;
	public showLoad = true;
	public hasData = false;
	public showLoad1 = true;
	public hasData1 = false;
	public getDisplayIndex = 0;
	public colorPalette: ColorPalette;
	public reloadSubscription;
	public widgetDataSubscription;
	public widgetTimelineSubscription;
	public chartConfig: any;
	public graphData: any;
	public baseConfig: any;
	public primaryColor = '';
	public secondaryColor = '';
	public tertiaryColor = '';
	hasLiftData = true;
	liftStatsData: any;
	avg_lift_max: number;

	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
	}

	@HostListener('window:resize', ['$event'])
	onResize(event: any): void {
		this.chartConfig = { ...this.chartConfig };
	}

	ngOnInit(): void {
		this.uikitresponseconfig = this.uikitresponseconfig ? JSON.parse(decodeURI(this.uikitresponseconfig)) : [];
		this.customchartconfiguration = this.customchartconfiguration
			? JSON.parse(decodeURI(this.customchartconfiguration))
			: {};

		this.baseConfig = {
			chartConfig: this.customchartconfiguration.chartConfig
		};
		this.requestData();
		this.colorsconfig =
			typeof this.colorsconfig === 'string' ? JSON.parse(decodeURI(this.colorsconfig)) : this.colorsconfig;
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
	}

	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
		if (this.widgetTimelineSubscription) {
			this.widgetTimelineSubscription.unsubscribe();
		}
	}

	requestData(): void {
		this.showLoad = true;
		this.hasData = false;
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
		this.widgetDataSubscription = this.analyticsService.processWidgetRequest(this.key).subscribe((res: any) => {
			if (res.success && res.data.length > 0) {
				this.campaignsList = res.data;
				const campaignListTemp = res.data;
				this.hasData = true;
				if (this.widgetTimelineSubscription) {
					this.widgetTimelineSubscription.unsubscribe();
				}
				this.widgetTimelineSubscription = this.analyticsService
					.processWidgetRequest(this.timeserieskey)
					.subscribe((response: any) => {
						this.showLoad = false;
						if (response.success && response.data.length > 0) {
							this.campaignsList = campaignListTemp;
							this.campaignsList.map((campaignItem) => {
								campaignItem.data = response.data.filter((obj) => obj.campaign_id === campaignItem.campaign_id);
							});
						} else {
							this.hasData = false;
							this.campaignsList = [];
						}
						this.processResponseData();
						this.campaignCarouselItem = this.campaignsList[this.getDisplayIndex];
					});
			} else {
				this.showLoad = false;
				this.hasData = false;
			}
		});

		this.hasData1 = false;
		this.showLoad1 = true;
		this.widgetDataSubscription = this.analyticsService
			.processWidgetRequest(this.secondarykey)
			.subscribe((res: any) => {
				this.showLoad1 = false;
				if (res.success && res.data.length) {
					this.hasData1 = true;
					this.processResponseStatsData(res.data);
				} else {
					this.hasData1 = false;
					this.hasLiftData = false;
				}
			});
	}

	processResponseStatsData(response: any): void {
		// tslint:disable-next-line: no-parameter-reassignment
		response = response[0];
		if (
			response.average_lift != null ||
			response.average_conversion_rate != null ||
			response.average_baseline != null
		) {
			this.liftStatsData = {
				baseLineRate: UtilityService.isUndefinedOrNull(response.average_baseline)
					? '<0.01'
					: parseFloat(response.average_baseline).toFixed(2),
				digitalLift: parseFloat(response.average_lift) > 100 ? '>99' : response.average_lift,
				exposedRate: parseFloat(response.average_conversion_rate).toFixed(2)
			};
			this.hasLiftData = true;
		} else {
			this.hasLiftData = false;
		}
	}

	processResponseData(): void {
		if (this.campaignsList) {
			for (const campaign of this.campaignsList) {
				if (campaign.data) {
					for (const campaignData of campaign.data) {
						campaignData.average_lift = Math.round(campaignData.average_lift);
						if (campaignData.average_lift >= 99) {
							campaignData.average_lift = 99;
						}
					}
				}
			}
			this.graphData = this.campaignsList[0].data;
			this.drawGraph();
		}
	}

	buildLiftDataObject(dataObject: any): any {
		const liftTempObj: any = {};
		if (Number(dataObject.average_lift.replace(/,/g, '')) > 99) {
			liftTempObj.displayLift = '>99';
			liftTempObj.str = '&gt;';
			liftTempObj.y = 99;
		} else {
			liftTempObj.displayLift = dataObject.average_lift;
			liftTempObj.y = parseInt(dataObject.average_lift, 10);
		}
		return liftTempObj;
	}

	drawGraph() {
		this.avg_lift_max = 0;
		if (this.graphData) {
			for (const campaign of this.graphData) {
				if (campaign.average_lift > this.avg_lift_max) {
					this.avg_lift_max = campaign.average_lift;
				}
			}
		}
		this.primaryColor = this.getColorFromColorConfiguration(this.colorsconfig[0]);
		this.secondaryColor = this.getColorFromColorConfiguration(this.colorsconfig[1]);
		this.tertiaryColor = this.getColorFromColorConfiguration(this.colorsconfig[2]);
		this.baseConfig.chartConfig.toolTip.borderColor = this.primaryColor;
		this.baseConfig.chartConfig.toolTip.formatter = this.getToolTipFormatter();

		if (this.baseConfig.chartConfig.series[0]) {
			if (typeof this.baseConfig.chartConfig.series[0].dataLabels.style.color === 'object') {
				this.baseConfig.chartConfig.series[0].dataLabels.style.color = this.getColorFromColorConfiguration(
					this.baseConfig.chartConfig.series[0].dataLabels.style.color
				);
			}
			this.baseConfig.chartConfig.series[0].point.events.mouseOver = this.changeLabelColorMouseOver();
			this.baseConfig.chartConfig.series[0].point.events.mouseOut = this.changeLabelColorMouseOut();
		}
		if (this.baseConfig && this.baseConfig.chartConfig && this.baseConfig.chartConfig.xAxis) {
			this.baseConfig.chartConfig.xAxis[0].lineColor = this.tertiaryColor;
			this.baseConfig.chartConfig.xAxis[1].lineColor = this.primaryColor;
		}
		if (this.baseConfig && this.baseConfig.chartConfig && this.baseConfig.chartConfig.yAxis[0]) {
			this.baseConfig.chartConfig.yAxis[0].title.style.color = this.secondaryColor;
			this.baseConfig.chartConfig.yAxis[0].ceiling = this.avg_lift_max;
			this.baseConfig.chartConfig.yAxis[0].tickAmount = undefined;
		}
		if (this.baseConfig && this.baseConfig.chartConfig && this.baseConfig.chartConfig.series[0]) {
			this.baseConfig.chartConfig.series[0].states.hover.color.gradientColor.stops = this.updateGradientColor(
				this.baseConfig.chartConfig.series[0].states.hover.color.gradientColor.stops
			);
		}
		this.chartConfig = {
			chartConfig: this.baseConfig.chartConfig,
			responseConfig: this.uikitresponseconfig
		};
	}

	getToolTipFormatter(): any {
		// tslint:disable-next-line: no-this-assignment
		const self = this;
		return function (): string {
			return `
			<div style='width: 9.5rem; padding: 3px;  >
				<div style='width: 100%;'>
				<div style='width: 46%; display:inline-block'>${this.x.replace('<br>', ' ')}</div>
				<div style='width: 100%; color: ${self.primaryColor}'>
					<div style='width: 46%; display:inline-block'>exposed</div>
					<div style='width: 46%; display:inline-block; text-align: right'>${this.point.average_conversion_rate}%</div>
				</div>
				<div style='width: 100%; color: ${self.secondaryColor}'>
					<div style='width: 46%; display:inline-block'>lift</div>
					<div style='width: 46%; display:inline-block; text-align: right'>${this.y}x</div>
				</div>
				<div style='width: 100%; color: ${self.tertiaryColor}'>
					<div style='width: 46%; display:inline-block'>baseline</div>
					<div style='width: 46%; display:inline-block; text-align: right'>${this.point.average_baseline}%</div>
				</div>
			</div>`;
		};
	}

	changeLabelColorMouseOver(): any {
		return function (): any {
			this.dataLabel.css({
				color: '#fff'
			});
		};
	}

	changeLabelColorMouseOut(): any {
		const self = this;
		return function (): any {
			this.dataLabel.css({
				color: self.getColorFromColorConfiguration(self.colorsconfig[1])
			});
		};
	}

	prevArrow(): void {
		if (this.campaignsList.length > 1) {
			if (this.getDisplayIndex === 0) {
				this.getDisplayIndex = this.campaignsList.length - 1;
			} else {
				this.getDisplayIndex = this.getDisplayIndex - 1;
			}
			this.campaignCarouselItem = this.campaignsList[this.getDisplayIndex];
			this.graphData = this.campaignsList[this.getDisplayIndex].data;
			if (
				this.campaignsList[this.getDisplayIndex].average_lift != null ||
				this.campaignsList[this.getDisplayIndex].average_conversion_rate != null ||
				this.campaignsList[this.getDisplayIndex].average_baseline != null
			) {
				this.liftStatsData = {
					baseLineRate: UtilityService.isUndefinedOrNull(this.campaignsList[this.getDisplayIndex].average_baseline)
						? '<0.01'
						: parseFloat(this.campaignsList[this.getDisplayIndex].average_baseline).toFixed(2),
					digitalLift:
						parseFloat(this.campaignsList[this.getDisplayIndex].average_lift) > 100
							? '>99'
							: this.campaignsList[this.getDisplayIndex].average_lift,
					exposedRate: parseFloat(this.campaignsList[this.getDisplayIndex].average_conversion_rate).toFixed(2)
				};
				this.hasLiftData = true;
			} else {
				this.hasLiftData = false;
			}
			this.drawGraph();
		}
	}

	nextArrow(): void {
		if (this.campaignsList.length > 1) {
			if (this.campaignsList.length - 1 === this.getDisplayIndex) {
				this.getDisplayIndex = 0;
			} else {
				this.getDisplayIndex = this.getDisplayIndex + 1;
			}
			this.campaignCarouselItem = this.campaignsList[this.getDisplayIndex];
			this.graphData = this.campaignsList[this.getDisplayIndex].data;
			if (
				this.campaignsList[this.getDisplayIndex].average_lift != null ||
				this.campaignsList[this.getDisplayIndex].average_conversion_rate != null ||
				this.campaignsList[this.getDisplayIndex].average_baseline != null
			) {
				this.liftStatsData = {
					baseLineRate: UtilityService.isUndefinedOrNull(this.campaignsList[this.getDisplayIndex].average_baseline)
						? '<0.01'
						: parseFloat(this.campaignsList[this.getDisplayIndex].average_baseline).toFixed(2),
					digitalLift:
						parseFloat(this.campaignsList[this.getDisplayIndex].average_lift) > 100
							? '>99'
							: this.campaignsList[this.getDisplayIndex].average_lift,
					exposedRate: parseFloat(this.campaignsList[this.getDisplayIndex].average_conversion_rate).toFixed(2)
				};
				this.hasLiftData = true;
			} else {
				this.hasLiftData = false;
			}
			this.drawGraph();
		}
	}

	updateGradientColor(stops: any[]): {} {
		for (const arr of stops) {
			if (typeof arr[1] === 'object') {
				arr[1] = this.getColorFromColorConfiguration(arr[1]);
			}
		}
		return stops;
	}

	getColorFromColorConfiguration(colorConfig: ColorConfig): string {
		let rgb = '';
		if (colorConfig.isHex) {
			rgb = this.colorUtilityService.getRGBByOpacity(colorConfig.color, colorConfig.opacity);
		} else {
			rgb = this.colorUtilityService.getRGBByColorType(this.colorPalette, colorConfig.color, colorConfig.opacity);
		}
		return rgb;
	}
}
